{
  "$schema": "./schema.json",
  "agents": {
    "reasonExplanation": {
      "title": "Ehdotus hakemustekstin parantamiseksi",
      "originalText": "Alkuperäinen teksti",
      "enhancedText": "Parannettu teksti",
      "generatingEnhancedTitle": "Luodaan parannettua tekstiä",
      "generatingEnhancedDescription": "Analysoimme ja optimoimme sisältöäsi",
      "acceptEnhanced": "Käytä parannettua tekstiä",
      "requestFurtherEnhancement": "Muokkaa ohjeita tekstin parantamiseksi",
      "cancel": "Peruuta",
      "button": "Tallenna",
      "regeneratePlaceholder": "Valinnainen: Lisää tarkennuksia tai ohjeita paremman tekstin saamiseksi…",
      "regenerateButton": "Luo uusi versio ohjeiden mukaan",
      "aiAssist": "Tekoäly-avustin",
      "tooltip": "Saa apua tekoälyltä hakemustekstin kirjoittamiseen"
    }
  }
}
